import { graphql } from '@teachino/shared-infrastructure';
import { baseLicenseFragment } from './base-license.fragment';
import { personalLicenseFragment } from './personal-license.fragment';
import { tenantLicenseFragment } from './tenant-license.fragment';

export const licensesQuery = graphql(
  `
    query Licenses {
      licenses {
        ...PersonalLicense
        ...BaseLicense
        ...TenantLicense
      }
    }
  `,
  [personalLicenseFragment, baseLicenseFragment, tenantLicenseFragment],
);
